import React from 'react'
import Link from 'gatsby-link'
import '../../sass/components/_menu.scss';

const Menu = (props) => (
  <nav className="menu">
    <ul className="links">
      <li><Link onClick={props.menuClick} to="/">Home</Link></li>
      <li><Link onClick={props.menuClick} to="/webshop/">webshop</Link></li>
      <li><Link onClick={props.menuClick} to="/experiences/">experiences</Link></li>
      {/*<li><Link onClick={props.menuClick} to="/events">events</Link></li>*/}
    </ul>
  </nav>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js